import React from "react";

import smallLogo from "../../assets/img/logo-small.png";
import municipioLogo from "../../assets/img/gadm.png";

import "../../assets/css/footer.css";

export const Footer = () => {
  return (
    <footer>
      <div className="container">
        <div className="row">
          <div className="col-6">
            <img
              src={smallLogo}
              alt="Logo Eslogan Macas"
              className="logo-macas"
            />
          </div>
          <div className="col-6">
            <img src={municipioLogo} alt="Logo del GAD Morona" />
            <p>
              <strong>Gobierno Municipal del Cantón Morona</strong>
              <br />
              Administración 2023-2027
            </p>
          </div>
        </div>
        <p className="small">
          2023 © Departamento de Tecnologías de la Información y Comunicación
        </p>
      </div>
    </footer>
  );
};
